export const MODEL_OBJ = 'model.obj'
export const BUILDING_JSON = 'building.json'
export const HEATERS_JSON = 'heaters.json'
export const FANS_JSON = 'fans.json'
